import { Component, OnInit } from '@angular/core';
import { MemberQuery, TermsAndConditionsModel, TermsAndConditionsService, TermsAndConditionsType } from '@fgb/core';
import { Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

@Component({
  selector: 'fgb-terms-page',
  templateUrl: './terms-page.component.html',
  styleUrls: ['./terms-page.component.scss'],
})
export class TermsPageComponent implements OnInit {
  termsAndConditionsType = TermsAndConditionsType.General;
  terms$: Observable<TermsAndConditionsModel[]>;

  constructor(private termsAndConditionsService: TermsAndConditionsService, private memberQuery: MemberQuery) {}

  ngOnInit() {
    // Fetching here fills the terms store, so the fgbcl component rendered afterwards reads from it instead of
    // firing a second request. Filtering out terms with no body text keeps the placeholder check out of the template.
    this.terms$ = this.memberQuery.userContext$.pipe(
      switchMap((member) =>
        this.termsAndConditionsService.getTermsAndConditions(this.termsAndConditionsType, member?.lcid, member?.clubId)
      ),
      map((terms) => terms?.filter((term) => !!term.BodyText) ?? [])
    );
  }
}
